import { Component } from '@angular/core';

@Component({
  templateUrl: './park-slidedown.html',
  selector: 'park-slidedown'
})
export class ParkSlidedownComponent {
  public state = false;

  public toggleState() {
    this.state = !this.state;
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/parks/park/slidedown/park-slidedown.component.ts